import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import MenuItem from '@material-ui/core/MenuItem';
import { connect } from 'react-redux';
import { renderTextField, requiredValidator } from 'utils/formHelper';
import {
  fetchOrganisation,
  updateOrganisation,
  createOrganisation
} from 'actions/organisations';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = {};

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false }
  };

  componentWillMount = () => {
    const { dispatch, orgId } = this.props;
    orgId && dispatch(fetchOrganisation(orgId));
  };

  submit = (attrs) => {
    const { dispatch, orgId, mode } = this.props;
    let action;
    if (mode === 'create') {
      action = createOrganisation(attrs);
    } else {
      action = updateOrganisation({ id: orgId, ...attrs });
    }
    return dispatch(action)
      .then(this.handleClose)
      .catch(this.handleSubmitFailure);
  }

  handleSubmitFailure = (error) => {
    if (error && error.response) {
      throw new SubmissionError(error.response);
    }
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  renderForm = () => {
    return (
      <div>
        <div className='form-row' >
          <Field
            name='name'
            component={renderTextField}
            label='Organisation name'
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='firstName'
            component={renderTextField}
            label='First Name'
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='lastName'
            component={renderTextField}
            label='Last Name'
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            select
            name='organisationType'
            component={renderTextField}
            label='Organisation type'
            validate={requiredValidator}
          >
            {
              [
                'Sole Proprietor',
                'Partnership',
                'Public Company',
                'Trustee Company',
                'Association',
                'Pty Ltd',
                'Other'
              ].map(option => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))
            }
          </Field>
        </div>
        <div className='form-row' >
          <Field
            name='abn'
            component={renderTextField}
            label="ABN/ACN"
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='email'
            component={renderTextField}
            label='Email'
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='phone'
            component={renderTextField}
            label='Phone'
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='website'
            component={renderTextField}
            label='Website'
          />
        </div>
        <div className='form-row' >
          <Field
            name='description'
            component={renderTextField}
            label='Description'
            multiline
          />
        </div>
      </div>
    );
  }

  title = () => {
    const { mode } = this.props;
    if (mode === 'create') {
      return 'Create Organisation';
    } else {
      return 'Update Organisation';
    }
  }

  render = () => {
    const { open } = this.state;
    const { handleSubmit, buttonLabel, buttonStyles, reset } = this.props;

    return (
      <div>
        <Button
          className={buttonStyles}
          color='primary'
          onClick={() => this.setState({ open: true })}
        >
          {buttonLabel}
        </Button>
        <Dialog
          open={open}
          onEnter={reset}
          onClose={this.handleClose}
        >
          <form onSubmit={ handleSubmit(this.submit) }>
            <DialogTitle>{this.title()}</DialogTitle>
            <DialogContent style={{ width: 500 }}>
              {this.renderForm()}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose}>CANCEL</Button>
              <Button type='submit' color='primary'>SUBMIT</Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  const initialValues = state.organisations && state.organisations[ownProps.orgId];
  return { initialValues };
};

const reduxed = reduxForm({ form: 'organisationForm', enableReinitialize: true })(Form);
const connected = connect(mapStateToProps)(reduxed);
export default withStyles(styles)(connected);



// WEBPACK FOOTER //
// ./src/components/Organisations/Form.js